/**
 * Public "Get the desktop app" page (/download). No session required — it
 * just surfaces the installer feed so staff (or an admin sharing the link)
 * can grab the native XOP Command Center for their OS. Reuses the same
 * `<DesktopDownloads>` buttons as the invitation-accept flow.
 */
import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";

import { DesktopDownloads } from "../components/DesktopDownloads.js";

export function DownloadPage(): JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: "30rem" }}>
        <CardHeader
          title="Get XOP Command Center"
          subheader="The native desktop app for the XOP staff dashboard"
        />
        <CardContent sx={{ display: "grid", gap: 2 }}>
          <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
            Install the desktop client for the best experience — it runs in the
            background with launch-on-login and delivers realtime notifications
            even when the window is closed.
          </Typography>
          <DesktopDownloads />
        </CardContent>
      </Card>
    </Box>
  );
}
